export default "__VITE_ASSET__093bc8cd__"